import { render, staticRenderFns } from "./UpcomingEvent.vue?vue&type=template&id=6f3f0e4a&scoped=true&"
import script from "./UpcomingEvent.vue?vue&type=script&lang=js&"
export * from "./UpcomingEvent.vue?vue&type=script&lang=js&"
import style0 from "./UpcomingEvent.vue?vue&type=style&index=0&id=6f3f0e4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3f0e4a",
  null
  
)

export default component.exports